(($) => {
	"use strict";

	$.enhancer("globalHeader", function () {

		

	});

})(jQuery);
